module.exports = __webpack_public_path__ + "site/img/companyProfile.4429274.png";


//////////////////
// WEBPACK FOOTER
// ./site/companyProfile.png
// module id = 95
// module chunks = 1